export default __webpack_public_path__ + "static/media/nvidia.1cb68eff.svg";